import(/* webpackMode: "eager" */ "D:\\UserData\\Desktop\\cyberex\\cyberex\\app\\product\\header.tsx")